import { fetchApi } from "./api";

export type HeroSlideEffect =
  | "kenburns"
  | "kenburns-reverse"
  | "zoom-in"
  | "zoom-out"
  | "pan-left"
  | "pan-right"
  | "none";

export type HeroSlideInput = {
  kicker?: string;
  title?: string;
  subtitle?: string;
  image_url?: string | null;
  image_path?: string | null;
  cta_primary_label?: string | null;
  cta_primary_href?: string | null;
  cta_secondary_label?: string | null;
  cta_secondary_href?: string | null;
  effect?: HeroSlideEffect;
  glass_alignment?:
    | "top-left" | "top-center" | "top-right"
    | "left" | "center" | "right"
    | "bottom-left" | "bottom-center" | "bottom-right"
    | null;
  image_position?:
    | "top-left" | "top-center" | "top-right"
    | "left" | "center" | "right"
    | "bottom-left" | "bottom-center" | "bottom-right"
    | null;
  glass_size?: "sm" | "md" | "lg" | null;
  glass_bg_color?: string | null;
  glass_bg_opacity?: number | null;
  kicker_color?: string | null;
  title_color?: string | null;
  subtitle_color?: string | null;
  cta_primary_bg?: string | null;
  cta_primary_fg?: string | null;
  cta_secondary_bg?: string | null;
  cta_secondary_fg?: string | null;
  is_active?: boolean;
  display_order?: number;
};

// Public: list hero slides.
export const listHeroSlides = () =>
  fetchApi<any[]>("content", "listHeroSlides", {}, { auth: false });

export const createHeroSlide = (opts: { data: HeroSlideInput }) =>
  fetchApi<any>("content", "createHeroSlide", opts.data);

export const updateHeroSlide = (opts: { data: HeroSlideInput & { id: string } }) =>
  fetchApi<any>("content", "updateHeroSlide", opts.data);

export const deleteHeroSlide = (opts: { data: { id: string } }) =>
  fetchApi<{ ok: true }>("content", "deleteHeroSlide", opts.data);

export const reorderHeroSlides = (opts: {
  data: { items: Array<{ id: string; display_order: number }> };
}) => fetchApi<{ ok: true }>("content", "reorderHeroSlides", opts.data);

// Admin: generate an image with AI, store it in the hero-slides bucket, and
// return { url, path } — contract unchanged for AIGenerateImageDialog.
export const generateHeroSlideImage = (opts: {
  data: { prompt: string; lookAndFeel?: string; width?: number; height?: number };
}) => fetchApi<{ url: string; path: string }>("media", "generateHeroSlideImage", opts.data);
